import { render } from "./iconIsotipoTexto.vue?vue&type=template&id=c67c587a&scoped=true"
import script from "./iconIsotipoTexto.vue?vue&type=script&lang=js"
export * from "./iconIsotipoTexto.vue?vue&type=script&lang=js"

import "./iconIsotipoTexto.vue?vue&type=style&index=0&id=c67c587a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c67c587a"

export default script